export default {
  en: {
    AREA_INFORMATION: 'Area Information',
    AREA_NAME: 'Area name',
    VESSEL_INFORMATION: 'Vessel Information',
    LENGTH: 'Length',
    BREADTH: 'Breadth',
    MOULDED_DEPTH: 'Moulded Depth',
    VESSE_UNITS: 'Units',
    METERS: 'Meters',
    FEET: 'Feet',
    GROSS_REGISTERED_TONNAGE: 'Gross Registered Tonnage',
    ASSIGNMENT_INFORMATION: 'Assignment Information',
    ASSIGNMENT_TYPE: 'Assignment type',
    PLEASE_SELECT: 'Please Select',
    Trip: 'Trip',
    Move: 'Move',
    Cancellation: 'Cancellation',
    'Detention On Board': 'Detention On Board',
    'Dead Ship': 'Dead Ship',
    'In Transit': 'In Transit',
    'Oil Rig': 'Oil Rig',
    'Over Carriage': 'Over Carriage',
    'Safety Watch': 'Safety Watch',
    'Through Transit': 'Through Transit',
    'Trial Trip': 'Trial Trip',
    EXPECTED_DURATION: 'Expected duration (Hours)',
    EXPECTED_DRAFT: 'Expected draft',
    DRAFT_UNITS: 'Draft units',
    NEED_A_PILOT_BOAT: 'Need a pilot boat?',
    YES: 'Yes',
    NO: 'No',
    SUBMIT: 'SUBMIT',
    RESET: 'RESET',
    Newfoundland: 'Newfoundland',
    'New Brunswick': 'New Brunswick',
    'Nova Scotia': 'Nova Scotia',
    'Prince Edward Island': 'Prince Edward Island',
    Quebec: 'Quebec',
    AMOUNT: 'Amount',
    TOTAL: 'Total',
    DESCRIPTION: 'Description',
    ANOTHER_CALCULATION: 'ANOTHER CALCULATION',
    REQUIRED_ERROR: 'Value is Required',
    FORMAT_ERROR: 'Value Must Be a Number',
  },
  fr: {
    AREA_INFORMATION: 'Renseignements sur la zone',
    AREA_NAME: 'Nom de la zone',
    VESSEL_INFORMATION: 'Renseignements sur le navire',
    LENGTH: 'Longueur',
    BREADTH: 'Largeur',
    MOULDED_DEPTH: 'Creux sur quille',
    VESSE_UNITS: 'Unités',
    METERS: 'Mètres',
    FEET: 'Pieds',
    GROSS_REGISTERED_TONNAGE: 'Jauge brute',
    ASSIGNMENT_INFORMATION: 'Renseignements sur l’affectation',
    ASSIGNMENT_TYPE: 'Type d’affectation',
    PLEASE_SELECT: 'Veuillez sélectionner',
    Trip: 'Voyage',
    Move: 'Déplacement',
    Cancellation: 'Annulation',
    'Detention On Board': 'Retenue à bord',
    'Dead Ship': "Navire à l'arrêt",
    'In Transit': 'Transport vers une zone de pilotage',
    'Oil Rig': 'Plateforme de forage pétrolier',
    'Over Carriage': "Transport au-delà d'une zone de pilotage",
    'Safety Watch': 'Quart de sécurité',
    'Through Transit': 'Transit',
    'Trial Trip': "Voyage d'essai",
    EXPECTED_DURATION: 'Durée prévue (heures)',
    EXPECTED_DRAFT: 'Tirant d’eau prévu',
    DRAFT_UNITS: 'Unités de tirant d’eau',
    NEED_A_PILOT_BOAT: 'Bateau-pilote nécessaire?',
    YES: 'Oui',
    NO: 'Non',
    SUBMIT: 'ENVOYER',
    RESET: 'RÉINITIALISER',
    Newfoundland: 'Terre-neuve',
    'New Brunswick': 'Nouveau-brunswick',
    'Nova Scotia': 'Nouvelle-écosse',
    'Prince Edward Island': 'île du Prince-Édouard',
    Quebec: 'Québec',
    AMOUNT: 'Montant',
    TOTAL: 'Total',
    DESCRIPTION: 'Description',
    ANOTHER_CALCULATION: 'UN AUTRE CALCUL',
    REQUIRED_ERROR: 'La valeur requise est requise',
    FORMAT_ERROR: 'La valeur doit être un nombre',
  },
}
